import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Outlet, useNavigate } from "react-router-dom";

import { useUser } from "../../../hooks/useUser";

export function AuthGuard() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: user, isLoading, authInitialized, session } = useUser();

  useEffect(() => {
    if (!authInitialized || isLoading) return;

    if (!user || !user.isMentor) {
      queryClient.removeQueries({ queryKey: ["supabaseUser"] });
    }

    if (!user) {
      navigate("/auth/login");
      return;
    }

    if (!user.isMentor) {
      navigate("/auth/login", { state: { authError: "not-mentor" } });
      return;
    }
  }, [authInitialized, isLoading, user, navigate, queryClient]);

  if (!authInitialized || isLoading || !session) {
    return null;
  }

  if (!user || !user.isMentor) {
    return null;
  }

  return <Outlet />;
}
